import { EmptystateChartColored } from "components/icons/generated";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import TileWrapper from "ds/components/Tile/Wrapper";

type DoraEmptyProps = {
  title: string;
  caption: string;
};

const DoraEmpty = ({ title, caption }: DoraEmptyProps) => {
  return (
    <TileWrapper>
      <Box padding="small" fullWidth justify="center">
        <EmptyState title={title} icon={EmptystateChartColored} caption={caption} />
      </Box>
    </TileWrapper>
  );
};

export default DoraEmpty;
